import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Projects from "../Pages/Projects/Projects";
import ProjectItems from "../Pages/Projects/ProjectItems";
import PrivateRoutes from "./PrivateRoutes";
import PublicRoutes from "./PublicRoutes";
import SignIn from "../Pages/SignIn/SignIn";
import Help from "../Pages/Help/Help";
import AddNewProject from "../Pages/Projects/AddNewProject";
import AccessDenied from "../Pages/AccessDenied/AccessDenied";
import MasterTable from "../components/Tables/MasterTable";
import AddNewMasterTable from "../components/AddNewMasterTable/AddNewMasterTable";
import { Callback } from "../components/Callback/Callback";

import MasterTableGrid from "../components/Tables/MasterTableGrid";
import ReportsTable from "../components/Tables/ReportsTable";
import CurrentSitesReport from "../components/Tables/CurrentSitesReport";
import PendingSitesReport from "../components/Tables/PendingSitesReport";
import StageSearchReport from "../components/Tables/StageSearchReport";

export default function Navigation() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<PrivateRoutes element={Projects} />} />
        <Route
          path="/login"
          element={<PublicRoutes element={SignIn} restricted={true} />}
        />
        <Route
          path="/auth/response"
          element={<PublicRoutes element={Callback} restricted={true} />}
        />

        <Route
          path="/unauthorized"
          element={<PublicRoutes element={AccessDenied} />}
        />
        <Route
          path="/projects"
          element={<PrivateRoutes element={Projects} />}
        />
        <Route
          path="/projects/add-new"
          element={<PrivateRoutes element={AddNewProject} />}
        />
        <Route
          path="/projects/:id"
          element={<PrivateRoutes element={ProjectItems} />}
        />
        <Route path="/help" element={<PrivateRoutes element={Help} />} />

        <Route
          path="/mastertables"
          element={<PrivateRoutes element={MasterTableGrid} />}
        />
        <Route
          path="/reports"
          element={<PrivateRoutes element={CurrentSitesReport} />}
        />
        <Route
          path="/reports/pending"
          element={<PrivateRoutes element={PendingSitesReport} />}
        />
        <Route
          path="/reports/stage-search"
          element={<PrivateRoutes element={StageSearchReport} />}
        />
        <Route
          path="/mastertables/:tab"
          element={<PrivateRoutes element={MasterTable} />}
        />
        <Route
          path="/mastertables/create-new"
          element={<PrivateRoutes element={AddNewMasterTable} />}
        />
      </Routes>
    </Router>
  );
}
